<template>
<v-container fluid>
      <v-card-title class="text-h8 blue darken-4 lighten-1 py-1">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="h6" style="color:white!important;">
              <v-icon color="white">fact_check</v-icon>
              Resultados de encuestas enviadas
            </div>
          </v-col>
        </v-row>
        <v-row>
        </v-row>
      </v-card-title>    
        <v-row class="mx-2 mt-2">
<v-col cols="2" md="2">        
                    <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                      :value=getDateFormated(date1)
                        label="Fecha Inicio"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        clearable
                        @click:clear="date1 = null"
                      ></v-text-field>                      
                    </template>
                    <v-date-picker
                      v-model="date1"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>    
</v-col>
<v-col cols="2" sm="2">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value=getDateFormated(date2)
                        label="Fecha Fin"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        clearable
                        @click:clear="date2 = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="date2"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>    
                </v-col>



                <v-col cols="2">
    
                    <select-campus  :id-campus-prop="idCampus" :fn-change="setIdCampus" :requerido="true" ></select-campus>
                
        </v-col>
         <v-col cols="2">
                    <select-division  :id-campus="idCampus" :id-division-prop="idDivision" :fn-change="setIdDivision" :requerido="false"></select-division>
         </v-col>  
<v-col cols="1" class="text-center">
                <v-btn
                  large
                  color="warning"
                  @click="getListadoResultadoEncuestas"
                >
               
                  Filtrar
                </v-btn>
                </v-btn>
            </v-col>
            <v-col cols="1">
              <dialog-indicadores-encuesta :obj-encuesta="objEncuesta" ></dialog-indicadores-encuesta>
            </v-col>
              <v-col cols="1" class="text-center">
                   <v-btn
                  large
                  color="success"
                  @click="getReporteResultadoEncuestas"
                >
                Excel
                <v-icon class="mr-2">download_for_offline</v-icon>          
                </v-btn>
          </v-col>
          <v-col 
            cols="3"   
          >
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              hide-details
              outlined
              dense
            />
          </v-col>
          
        </v-row>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
      <template v-if="loading==false" v-slot:item.fechaConstestada="{ item }">
          {{ getDateFormated(item.fechaConstestada) }}
        </template>
       <template v-if="loading==false" v-slot:item.linkRespuesta="{ item }"> 
       <div v-if="item.linkRespuesta === ''">
      </div>
      <div v-else>
      <a v-if="item.linkRespuesta!=null" color="primary" v-bind:href="item.linkRespuesta" target="_blank">Ver respuestas</a>
</div>         
        </template>
        <template  v-if="loading==false" v-slot:item.encuestaContestada="{ item }">
<div v-if="item.encuestaContestada === 'SI'">
   <v-icon color="green">
           mdi-check 
          </v-icon>
      </div>
      <div v-else>
        <v-icon color="red">
          mdi-close
          </v-icon>
      </div>
</div></template>
        
      </v-data-table>
    </v-card-text>
  </v-card>
 
  <v-snackbar
    key="snackbarDataTableServicioResponsables"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import { mapGetters, mapActions, mapState } from "vuex";
import XLSX from 'xlsx';
import {getListadoResultadoEncuestaByFecha, getListadoResultadoEncuestaIndicadores,getListadoResultadoEncuestaExcel, getReportesByIdEncuesta } from "@/api";

export default {
  name: "DataTableEncuestaRespuestas",
  components: {
     DialogIndicadoresEncuesta: () =>import("../bandejaEncuestas/IndicadoresEncuesta"),
      SelectCampus: () => import("../comunes/SelectCampusR"),
    SelectDivision: () => import("../comunes/SelectDivisionR"),
  },
  props: {
    objEncuesta: {
      type: Object,
      required: true
    },
    fnOnLoaded: {
      type: Function,
      default: () => {}
    },
    fnSetEditRol: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: true,
      snackbar: false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
      { align: "left", text: "Id", value: "idResultadoEncuesta" },
        { align: "left", text: "Nua", value: "nua" },
        { align: "left", text: "Nue", value: "nue" },
        { align: "left", text: "Nombre", value: "nombre" },
        { align: "left", text: "Correo", value: "corrreo" },
           { align: "left", text: "Campus", value: "campus" },
        { align: "left", text: "Respuesta", value: "encuestaContestada" },
        { align: "left", text: "Fecha de respuesta", value: "fechaConstestada" },
        { align: "left", text: "linkRespuesta", value: "linkRespuesta" },
      ],
      items: [],
      preguntas: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},
      itemDelete: {},
      dialogEliminar:  false,
      loadingEliminar: false,
     itemsPreguntas:[],
      date1:"",
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      menu1: false,
       idCampus: null,
      campus: null,
      idDivision: null,
      division: null,

    };
  },
  computed: {},
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
   
   this.getListadoResultadoEncuestas();
			},
    },
  },
  async mounted () {
    const fecha =new Date();
     this.date1=new Date(fecha.getFullYear(), fecha.getMonth(), 1).toISOString().substr(0, 10), +'00:00:00.000';
    this.getListadoResultadoEncuestas();
  },
  methods: {
     async getListadoResultadoEncuestas () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";
      var fecha2 = self.date2;
      try {
        let response;
        if(self.mostrarTodos==true){

response = await getListadoResultadoEncuestaByFecha(self.objEncuesta.idEncuesta, '', '');
        }
else{
   if(self.idCampus==null){
   response = await getListadoResultadoEncuestaByFecha(self.objEncuesta.idEncuesta, self.date1.substr(0,10), self.date2, '', '');
   }
    else{
        if(self.idCampus!=null&&self.idDivision==null){
 response = await getListadoResultadoEncuestaByFecha(self.objEncuesta.idEncuesta, self.date1.substr(0,10), self.date2, self.idCampus, '');

        }
        else{
        
        if(self.idCampus!=null&&self.idDivision!=null){
          response = await getListadoResultadoEncuestaByFecha(self.objEncuesta.idEncuesta, self.date1.substr(0,10), self.date2, self.idCampus, self.idDivision);

        }
        }

        }

        
}
     if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.items = response.data.data;
              self.loading = false;
            }
          } else {
            self.snackbarTexto = "DataTableEncuestaRoles: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableEncuestaRoles: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestaRoles: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
         async getReporteResultadoEncuestas () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";
      var fecha2 = self.date2;
let response="";
try {


if(self.idCampus==null){
   response = await getReportesByIdEncuesta(self.objEncuesta.idEncuesta, self.date1.substr(0,10), self.date2, '', '');      
   }
    else{
        if(self.idCampus!=null&&self.idDivision==null){
  response = await getReportesByIdEncuesta(self.objEncuesta.idEncuesta, self.date1.substr(0,10), self.date2, self.idCampus, '');      
        }
        else{
        
        if(self.idCampus!=null&&self.idDivision!=null){
         response = await getReportesByIdEncuesta(self.objEncuesta.idEncuesta, self.date1.substr(0,10), self.date2, self.idCampus, self.idDivision);      
        }
        }
        }

    const url = URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute(
      'download',
      `ResultadosEncuesta.xlsx`
    )
    document.body.appendChild(link)
    link.click()       
     this.getListadoResultadoEncuestas();
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableResultadosEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
       getDateFormated(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY h:mm:ss a');
      }
    },
     setIdCampus(objCampus){
      this.idCampus = objCampus.id;
      this.campus = objCampus.descripcion;
    },
    setIdDivision(objDivision){
      this.idDivision = objDivision.id;
      this.division = objDivision.descripcion;
    },
  }
};
</script>